import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFortranComponent } from './simple-icons-fortran.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFortranComponent ],
    exports:      [ SimpleIconsFortranComponent ],
    bootstrap:    []
})
export class SimpleIconsFortranModule {}
